<div class="gutter">
	<div class="product-content-wrap">
		<div class="product-gallery" [class.loading-content]="product.id == 0">
			<ng-container *ngIf="product.photos && product.photos.length > 0">
				<swiper  #swiper [config]="config" [thumbs]="{ swiper: thumbsSwiper }" [zoom]="true">
					<ng-template swiperSlide *ngFor="let slide of product?.photos; let i = index" [ngSwitch]="slide.extension">
						<ng-template ngSwitchCase="mp4">
							<app-video [urls]="[{u: slide | img:'desktop':'normal', w: 720, h: 720}]" [fit]="false" [autoplay]="false" [playPause]="i == swiper?.swiperRef?.activeIndex" [mediaStremEnabled]="false" [muted]="false"></app-video>
						</ng-template>
						<ng-template ngSwitchDefault>						
							<picture>
								<source media="(min-width: 600px)" [srcset]="slide | img:'desktop':'webp':'medium_'" type="image/webp">
								<source media="(min-width: 600px)" [srcset]="slide | img:'desktop':'normal':'medium_'">
								<source [srcset]="slide | img:'mobile':'webp'" type="image/webp">
								<img [src]="slide | img:'mobile':'normal'" (click)="openGallery()">
							</picture>
							<ng-container *ngIf="slide.title !== slide.alt">
								<p class="photo-description">{{ slide.title }}</p>
							</ng-container>
						</ng-template>
					</ng-template>
				</swiper>
				<swiper
					(swiper)="thumbsSwiper = $event"
					[spaceBetween]="8"
					[slidesPerView]="6"
					[freeMode]="true"
					[watchSlidesProgress]="true"
					class="thumbs">
					<ng-template swiperSlide *ngFor="let slide of product?.photos; let i = index" [ngSwitch]="slide.extension">
						<ng-template ngSwitchCase="mp4">
							<div class="video-icon"><svg class="icon icon-xl icon-play-circle"><use xlink:href="#icon-play-circle"></use></svg></div>
						</ng-template>
						<ng-template ngSwitchDefault>						
							<picture>
								<source media="(min-width: 600px)" [srcset]="slide | img:'desktop':'webp':'medium_'" type="image/webp">
								<source media="(min-width: 600px)" [srcset]="slide | img:'desktop':'normal':'medium_'">
								<source [srcset]="slide | img:'mobile':'webp'" type="image/webp">
								<img [src]="slide | img:'mobile':'normal'">
							</picture>
							<ng-container *ngIf="slide.title !== slide.alt">
								<p class="photo-description">{{ slide.title }}</p>
							</ng-container>
						</ng-template>
					</ng-template>
				</swiper>
				<p *ngIf="!isMobile" class="infobox small" i18n>Informacje zawarte na stronie internetowej nie są prawnie wiążące i nie stanowią oferty handlowej, w tym w rozumieniu art. 66 § 1 prawa cywilnego. Zdjęcie produktu może odbiegać od jego rzeczywistego wyglądu i ten fakt nie może stanowić podstawy zgłoszenia reklamacyjnego.</p>
			</ng-container>
		</div>
		<div #productContent class="product-content" [style.top.px]="stickyTopContentColumn">

			<div class="flx-col flx-gap-default">
				<div class="favorite flx-row flx-btwn-strt flx-gap-half">
					<div class="badges flx-row flx-strt-cntr flx-gap-default">
						<span *ngIf="+product?.price_promo" class="badge discount" i18n>promocja</span>
						<span *ngIf="+product?.day" class="badge feat" i18n>polecamy</span>
						<span *ngIf="+product?.bestseller && isLoggedIn" class="badge bestseller" i18n="@@promountil">promocja do 20.09.2024</span>
						<span *ngIf="+product?.new" class="badge new" i18n>nowość</span>
					</div>
					<button class="icon-button" aria-label="Do ulubionych" (click)="addToFavorites()"><svg class="icon icon-xl icon-heart-o"><use xlink:href="#icon-heart-o"></use></svg></button>
				</div>

				<div [class.loading-content]="product.id == 0">
					<h1 [innerHtml]="product.title"></h1>
				</div>

				<div *appShowB2b="'show_prices'"  class="sticky-price flx-col flx-strt-strt" [class.loading-content]="product.id == 0">
					<app-price class="price-selected" [id]="product.id" 
					    [price]="(+selectedVariant.price)"
						[price_promo]="((+selectedVariant.price_promo > 0) ? (+selectedVariant.price_promo) : 0)"
						[tax]="selectedVariant.tax" [currency]="selectedVariant.currency" [discounts]="discounts"
						[manufacturer]="product.id_manufacturer" [series]="product.series" [category]="product.categories"
						[quantity]="1">
					</app-price>
					<div class="flx-dynamic flx-gap-half w-100">
						<button class="decoder-button flx-dynamic flx-btwn-strt w-100 flx-grw" (click)="toggleDecoder()" [innerHtml]="product.extra_1 ? product.extra_1 : selectedVariant.sku"></button>
						<div class="flx-row" *ngIf="+product.extra_content_3 != 1 && +product.configurable == 1">
						<button class="decoder-button flx-grw" (click)="toggleDecoder()">	
							<span *ngIf="!decoder_visible" ><ng-container i18n="@@appdectg1">ROZWIŃ DANE TECHNICZNE</ng-container>
								<svg class="icon icon-chevron-down"><use xlink:href="#icon-chevron-down"></use></svg>
							</span>
							<span *ngIf="decoder_visible" ><ng-container i18n="@@appdectg2">ZWIŃ DANE TECHNICZNE</ng-container>
								<svg class="icon icon-chevron-up"><use xlink:href="#icon-chevron-up"></use></svg>
							</span>
						</button>
						</div>
						<button class="decoder-button flx-grw" (click)="copyCode()"><span i18n>SKOPIUJ KOD</span></button>
					</div>
					<div class="decoder-wrap" *ngIf="product.id != 0 && decoder_visible && +product.configurable == 1">
						<app-decoder [code]="product.extra_1 ? product.extra_1 : selectedVariant.sku"></app-decoder>
						<ul>
							<li *ngFor="let attribute of product.search_attributes">{{ attribute.title }}: <b>{{ attribute.value_text }}</b></li>
							<li *ngFor="let attribute of selectedVariant.attributes">{{ attribute.title }}: <b>{{ attribute.value_text }}</b></li>
						</ul>
					</div>
				</div>
				
				<div [innerHtml]="product.content" [class.loading-content]="product.id == 0" style="padding: 0 12px"></div>
				<div class="techdata initial">
					<div class="row flx-dynamic" *ngFor="let attribute of selectedVariantVisibleAttrs">
						<div class="col">{{ attribute.title }}</div>
						<div class="col">{{ attribute.value_text }}<span *ngIf="attribute.id_attribute == 9 || attribute.id_attribute == 10">- <ng-container i18n="@@attrconf">wartość zmienna w zależności od konfiguracji przyczepy</ng-container></span></div>
					</div>
				</div>
				<!-- <mat-accordion displayMode="flat">
					
					<mat-expansion-panel class="mat-elevation-z0">
						<mat-expansion-panel-header>
						<mat-panel-title i18n="@@details">Szczegóły</mat-panel-title>
						</mat-expansion-panel-header>

						<div>
							<div class="techdata">
								<div class="row flx-dynamic" *ngFor="let attribute of product.search_attributes">
									<div class="col">{{ attribute.title }}</div>
									<div class="col">{{ attribute.value_text }}</div>
								</div>
								<div class="row flx-dynamic" *ngFor="let attribute of selectedVariant.attributes">
									<div class="col">
										{{ attribute.title }}
									</div>
									<div class="col">{{ attribute.value_text }} <span *ngIf="attribute.id_attribute == 9 || attribute.id_attribute == 10" i18n="@@attrconf">wartość zmienna w zależności od konfiguracji przyczepy</span></div>
								</div>
							</div>
							<br>
							<div class="w-100 flx-dynamic flx-gap-default">
								<button class="stroked-button w-50-md" (click)="getSpecsheet('simple')" [disabled]="laodingSpecsheet"><ng-container i18n="@@getspecsheet">Pobierz kartę techniczną</ng-container><div *ngIf="laodingSpecsheet" class="loader-circle"></div></button>
								<button class="stroked-button w-50-md" (click)="downloadFiles()" [disabled]="laodingSpecsheet"><ng-container i18n="@@getmarketing">Pobierz materiały marketingowe</ng-container><div *ngIf="laodingSpecsheet" class="loader-circle"></div></button>
							</div>
						</div>
					</mat-expansion-panel>

					<mat-expansion-panel class="mat-elevation-z0" *ngIf="extra_field_4 !== '-'">
					<mat-expansion-panel-header>
						<mat-panel-title i18n>Konserwacja i użytkowanie</mat-panel-title>
					</mat-expansion-panel-header>
				
					<div [innerHtml]="extra_field_4"></div>
					
					</mat-expansion-panel>

					<mat-expansion-panel class="mat-elevation-z0" *ngIf="extra_field_5 !== '-'">
						<mat-expansion-panel-header>
							<mat-panel-title i18n>Bezpieczeństwo i recykling</mat-panel-title>
						</mat-expansion-panel-header>
						<div [innerHtml]="extra_field_5"> </div>
					</mat-expansion-panel>

					<mat-expansion-panel class="mat-elevation-z0" *ngIf="model.length">
						<mat-expansion-panel-header>
						<mat-panel-title i18n>Do pobrania</mat-panel-title>
						</mat-expansion-panel-header>
						<div>
							<div class="techdata">
								<div class="row flx-dynamic" *ngFor="let element of model">
									<div class="col">{{element.title}}</div>
									<div class="col">{{element.extension}}</div>
									<div class="col">
										
										<svg *ngIf="!isLoggedIn" matTooltip="ZALOGUJ SIĘ ŻEBY POBRAĆ MODEL 3D" i18n-matTooltip matTooltipPosition="above" class="icon icon icon-exclamation"><use xlink:href="#icon-exclamation"></use></svg>
										<a class="flat-button" *ngIf="isLoggedIn" href="{{ cdn }}/products/{{ product.photos_directory }}/{{ element.filename }}" i18n="@@download">Pobierz</a>

									</div>
								</div>
							</div>
						</div>
					</mat-expansion-panel>
				</mat-accordion>	 -->

				<ng-container *ngIf="(attributes.length > 0 || product.variants?.length > 1 || product.related?.length > 0)">
					<mat-tab-group dynamicHeight>
					<mat-tab label="Konfiguruj produkt" i18n-label="@@tab_conf" *ngIf="attributes.length > 0 && isLoggedIn && +product.configurable == 1">
						<div class="attr-group"  *ngFor="let group of attributes; let i = index">
							<ng-container [ngSwitch]="group.additional">

								<h4 *ngSwitchCase="'header'">{{ group.name }}</h4>

								<ng-container *ngSwitchCase="'product'">
									<label>{{ group.name }}</label>
									<mat-form-field appearance="outline" class="w-100">
										<mat-select [value]="group.attrs[0]" (selectionChange)="attrSelectChange(i, $event, group.real, group.additional)" [disabled]="priceChangeLoading | async">
										<mat-option *ngFor="let attr of group.attrs" [value]="attr">
												<ng-container *ngIf="attr.product && attr.product?.price > 0">
													<app-image [url]="cdn+'/products/'+attr.product.photos_directory+'/thumb_'+attr.product.photo" [natural]="true"></app-image> 
													<app-price [id]="attr.product.id" [price]="attr.product.price"
															[price_promo]="attr.product.price_promo" [tax]="attr.product.tax" [currency]="attr.product.currency" [discounts]="discounts"
															[manufacturer]="attr.product.id_manufacturer" [series]="attr.product.series" [category]="attr.product.categories"
															[quantity]="1">
													</app-price>
												</ng-container>
												{{ attr.name }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</ng-container>

								<ng-container *ngSwitchCase="'category'">
									<label>{{ group.name }}</label>
									<mat-form-field appearance="outline" class="w-100">
										<mat-select [compareWith]="compareFn" [value]="+selectedAdditionalAttribute[group.real]?.id"  (selectionChange)="attrSelectChange(i, $event, group.real, group.additional)"  [disabled]="group.attrs.length == 1 || (priceChangeLoading | async)">
											<mat-option *ngFor="let attr of group.attrs" [value]="attr">
												<ng-container *ngIf="attr.price > 0 && group.attrs.length > 1">
													<app-price [price]="attr.price" [tax]="attr.tax" [currency]="attr.currency" [quantity]="1"></app-price>
												</ng-container>
												{{ attr.name }} <ng-container *ngIf="group.attrs.length == 1 || attr.name == ''" i18n>- w standardzie modelu</ng-container>
											</mat-option>
										</mat-select>
									</mat-form-field>
								</ng-container>

								<ng-container *ngSwitchCase="'normal'">
									<label>{{ group.name }}</label>
									<div class="flx-row flx-strt-cntr flx-gap-default">
										<button *ngFor="let attr of group.attrs"  class="attr flx-col" [class.active]="+selectedAttribute[group.real]?.id == +attr.id_attribute_variant" (click)="attrButtonChange(attr, group.real, group.additional)" [disabled]="priceChangeLoading | async">
											<span class="square-wrap" *ngIf="attr.filename" >
												<app-image url="{{ cdn }}/attributes/{{ attr.photos_directory }}/medium_{{attr.filename}}"></app-image>
											</span>
											<span *ngIf="!attr.filename" class="attr-name"> {{ attr.name }} </span>
										</button>
									</div>
								</ng-container>

							</ng-container>
						</div>
					</mat-tab>
					<mat-tab label="Wybierz polecany wariant" i18n-label="@@tab_variant" *ngIf="product.variants?.length > 1">
							<a [routerLink]="['/'+path_offer_details, this.path, variant.id]" *ngFor="let variant of product.variants" class="variant flx-dynamic  flx-strt-strt flx-strt-cntr-md" [class.active]="selectedVariant.id === variant.id">
								<app-image *ngIf="variant.photo" [natural]="true" [url]="cdn +'/products/'+ product.photos_directory + '/thumb_' + variant.photo"></app-image>
								<div>
									<h4>{{ product.title }}</h4>
									<p>{{ variant.sku }}</p>
									<!-- <ng-container *ngIf="variant.attributes.length">
										<ul>
											<li *ngFor="let attr of variant.attributes">{{ attr.title }}: {{ attr.value_text }}</li>
										</ul>
									</ng-container> -->
									<app-decoder [code]="variant.sku" [type]="[1,3]"></app-decoder>
								</div>
								<app-price *appShowB2b="'show_prices'" [id]="product.id" [price]="variant.price"
									[price_promo]="variant.price_promo" [tax]="variant.tax" [currency]="variant.currency" [discounts]="discounts"
									[manufacturer]="product.id_manufacturer" [series]="product.series" [category]="product.categories"
									[quantity]="1">
								</app-price>
							</a>
					</mat-tab>
					<mat-tab label="Dostępne akcesoria" i18n-label="@@tab_akc" *ngIf="product.related?.length > 0">
						<div *ngFor="let related of product.related" class="flx-col variant">
							<a [routerLink]="['/'+path_offer_details, related.path, related.variant_id]" class="flx-row variant flx-strt-strt">
								<app-image [natural]="true" [url]="cdn +'/products/'+ related.photos_directory + '/thumb_' + related.photo"></app-image>
								<div>
									<h5>{{ related.title }}<br><span>{{ related.series }}</span></h5>
									<ul>
										<li *ngFor="let attr of related.variants[related.variant_selected].attributes">{{ attr.title }}: {{ attr.value_text }}</li>
									</ul>
								</div>
								<app-price *appShowB2b="'show_prices'" [id]="product.id" [price]="related.variants[related.variant_selected].price"
									[price_promo]="related.variants[related.variant_selected].price_promo" [tax]="related.variants[related.variant_selected].tax" [currency]="related.variants[related.variant_selected].currency" 
									[discounts]="discounts" [manufacturer]="related.id_manufacturer" [series]="related.series" [category]="related.categories" [quantity]="1">
								</app-price>
							</a>
							<div *appShowB2b="'allow_orders'" class="related-actions flx-dynamic flx-gap-default">
								<div class="loader-circle"></div>
								<div class="flx-row flx-cntr-cntr">
									<button class="stroked-button btn-quantity" (click)="minus(related.variants[related.variant_selected])" ><svg class="icon icon-minus"><use xlink:href="#icon-minus"></use></svg></button>
									<input class="input-quantity" [value]="related.variants[related.variant_selected].quantity_to_add || 1" (change)="changeQuantity($event, related.variants[related.variant_selected])">
									<button class="stroked-button btn-quantity" (click)="plus(related.variants[related.variant_selected])"><svg class="icon icon-plus"><use xlink:href="#icon-plus"></use></svg></button>
								</div>
								<button class="flat-button primary fat flx-grw" (click)="addRelatedToCart(related)"  i18n="@@addtocart" [disabled]="priceChangeLoading | async">DODAJ DO KOSZYKA</button>
							</div>
						</div>
					</mat-tab>
					</mat-tab-group>
				</ng-container>

				<button *ngIf="isLoggedIn" class="stroked-button w-100" (click)="getSpecsheet('complex')" [disabled]="laodingSpecsheet"><ng-container i18n="@@generateoffer">Wygeneruj ofertę dla klienta</ng-container><div *ngIf="laodingSpecsheet" class="loader-circle"></div></button>
				<button class="stroked-button w-100" (click)="getSpecsheet('simple')" [disabled]="laodingSpecsheet"><ng-container i18n="@@getspecsheet">Pobierz kartę techniczną</ng-container><div *ngIf="laodingSpecsheet" class="loader-circle"></div></button>
				
				<div *appShowB2b="'allow_orders'" class="action-buttons flx-dynamic flx-gap-default">
					<div class="flx-row flx-cntr-cntr">
						<button class="stroked-button btn-quantity" (click)="minus(selectedVariant)" ><svg class="icon icon-minus"><use xlink:href="#icon-minus"></use></svg></button>
						<input class="input-quantity" [value]="selectedVariant.quantity_to_add"  (change)="changeQuantity($event, selectedVariant)">
						<button class="stroked-button btn-quantity" (click)="plus(selectedVariant)"><svg class="icon icon-plus"><use xlink:href="#icon-plus"></use></svg></button>
					</div>
					<button class="flat-button primary fat flx-grw" (click)="addToCart()" i18n="@@addtocart" [disabled]="priceChangeLoading | async">DODAJ DO KOSZYKA</button>
				</div>
				<div *appShowB2b="'disallow_orders'" class="action-buttons flx-dynamic flx-gap-default">
					<a [routerLink]="['/'+path_dealers]" class="flat-button primary fat flx-grw" i18n="@@wheretobuy">GDZIE KUPIĆ</a>
				</div>

			</div>
			<div class="flx-col flx-gap-default">

				<div>
					<ng-container *ngIf="products.length > 0">
						<div class="products-related hidex flx-col">
							<h4 i18n="@@related_accessories">Pasujące akcesoria</h4>
							<swiper [slidesPerView]="3" [spaceBetween]="16" [navigation]="true" [breakpoints]="{'@0.00': {slidesPerView: 2}, '@0.75': {slidesPerView: 2}, '@1.00': {slidesPerView: 3}, '@1.50': {slidesPerView: 3}}">
								<ng-template swiperSlide *ngFor="let product of products; let j = index;">
									<app-product [product]="product"></app-product>
								</ng-template>
							</swiper>
						</div>
					</ng-container>
				</div>

				<div>
					<ng-container *ngIf="products_similiar.length > 0">
						<div class="products-related hidex flx-col" >
							<h4 i18n="@@related_products">Podobne produkty</h4>
							<swiper [slidesPerView]="3" [spaceBetween]="16" [navigation]="true" [breakpoints]="{'@0.00': {slidesPerView: 2}, '@0.75': {slidesPerView: 2}, '@1.00': {slidesPerView: 3}, '@1.50': {slidesPerView: 3}}">
								<ng-template swiperSlide *ngFor="let product of products_similiar; let j = index;">
									<app-product [product]="product"></app-product>
								</ng-template>
							</swiper>
						</div>
					</ng-container>
				</div>


			</div>

		</div>
	</div>
</div>

